import PropTypes from "prop-types";
import React, { useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/profile-img.png";
import SignInWithGoogle from "components/SignInWithGoogle";

import logo from "assets/images/aesbill/logo.svg";
import logoLight from "../../assets/images/aesbill/logo.svg";
import logoLightSvg from "../../assets/images/aesbill/logo.svg";
import logoDark from "../../assets/images/aesbill/logo.svg";

const Login = props => {

  //meta title
  document.title = "Вход | AESbill";

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Пожалуйста, введите Email"),
      password: Yup.string().required("Пожалуйста, введите пароль"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    }
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      error: login.errors?.response?.data?.errors,
      loading: login.loading
    })
  );

  const {
    error, loading
  } = useSelector(LoginProperties);

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  const authError = useSelector(state => state?.Login?.error?.response?.data?.errors);

  //for facebook and google authentication
  const socialResponse = type => {
    signIn(type);
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  return (
    <React.Fragment>
      <header id="page-topbar" style={{'left': 0}}>
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="50" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="50" />
                </span>
              </Link>
            </div>
            <div className="font-size-12 align-middle d-none d-sm-block" style={{'placeSelf': 'center', 'width': 150}}>
              Мобильное приложение для выставления и оплаты счетов
            </div>

          </div>
        </div>
      </header>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <div className="text-center mb-5">
                <h4>Кабинет для оплаты подписĸи AESBILL</h4>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Добро пожаловать!</h5>
                        <p>Вход только для зарегистрированных пользователей AESbill.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={logo} alt="" className="img-fluid" style={{marginBottom: "10px", marginRight: "10px", float: "right", height: "120px"}} />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-3">
                        <Label className="form-label">Почта</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Укажите почту"
                          type="email"
                          disabled={loading}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            ((validation.touched.email && validation.errors.email) || (authError && authError.email)) ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                        {authError && authError.email ? (
                          <FormFeedback type="invalid">{authError.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Пароль</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          disabled={loading}
                          placeholder="Укажите пароль"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            ((validation.touched.password && validation.errors.password) || (authError && authError.password)) ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                        {authError && authError.password ? (
                          <FormFeedback type="invalid">{authError.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          Войти
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <h5 className="font-size-14 mb-3">Войти с помощью</h5>
                        <SignInWithGoogle />
                      </div>

                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} <Link to="https://aesbill.com/" target="_blank">AESbill</Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
